/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.dev/license
 */

// THIS CODE IS GENERATED - DO NOT MODIFY.
const u = undefined;

function plural(val: number): number {
const n = val;

return 5;
}

export default ["ko",[["AM","PM"],u,["ì¤ì ","ì¤í"]],u,[["ì¼","ì","í","ì","ëª©","ê¸","í "],u,["ì¼ìì¼","ììì¼","íìì¼","ììì¼","ëª©ìì¼","ê¸ìì¼","í ìì¼"],["ì¼","ì","í","ì","ëª©","ê¸","í "]],u,[["1ì","2ì","3ì","4ì","5ì","6ì","7ì","8ì","9ì","10ì","11ì","12ì"]],u,[["BC","AD"],u,["ê¸°ìì ","ìê¸°"]],0,[6,0],["yy. M. d.","y. M. d.","yë MMMM dì¼","yë MMMM dì¼ EEEE"],["a h:mm","a h:mm:ss","a hì më¶ sì´ z","a hì më¶ sì´ zzzz"],["{1} {0}",u,u,u],[".",",",";","%","+","-","E","Ã","â°","â","NaN",":"],["#,##0.###","#,##0%","Â¤#,##0.00","#E0"],"KRW","â©","ëíë¯¼êµ­ ì",{"AUD":["AU$","$"],"BYN":[u,"Ñ."],"JPY":["JPÂ¥","Â¥"],"PHP":[u,"â±"],"RON":[u,"L"],"TWD":["NT$"],"USD":["US$","$"]},"ltr", plural];
